import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import CartPage from '../../CartPage/CartPage'
import { useHasMode } from '../../ModeRouter/ModeRouter'

import './MenuPageLayout.css'

const MenuPageLayout = ({ menus, cart, header }) => {
  const isCartMode = useHasMode('cart')

  return (
    <React.Fragment>
      {isCartMode && (
        <div styleName='cartMobile'>
          <CartPage />
        </div>
      )}
      <div styleName={cx('splitView', { cartMobile: isCartMode })}>
        <div styleName='content'>
          {header}
          <div styleName='menus'>{menus}</div>
        </div>
        <div styleName='cart'>
          <div styleName='fixed'>
            <h2 styleName='label'>Your Order</h2>
            {cart}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

MenuPageLayout.propTypes = {
  menus: PropTypes.node.isRequired,
  cart: PropTypes.node.isRequired,
  header: PropTypes.node
}

export default MenuPageLayout
